// 根据环境引入不同配置 process.env.NODE_ENV 
const { baseUrl,url,appid } = require('./env.' + process.env.NODE_ENV)

export const BASEURL = baseUrl;
export const DOMAINURL = url;
export const APPID = appid;

export const TITLE = "湖畔书店 1元拍西文书(每周上新)";